import { render, staticRenderFns } from "./ActionRadioGroup.vue?vue&type=template&id=d5ac3776"
import script from "./ActionRadioGroup.vue?vue&type=script&lang=ts"
export * from "./ActionRadioGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports